import { FC } from "react";
import { ContactDetails } from "./ContactDetails";
import { PaymentDetails } from "./PaymentDetails";
import { TermsAndConditions } from "./TermsAndConditions";

interface PersonalDetailsFormProps {
    insideElements?: boolean
    setStripeComplete: React.Dispatch<React.SetStateAction<boolean>>
    clientSecret?: string
}

export const PersonalDetailsForm: FC<PersonalDetailsFormProps> = ({
    setStripeComplete,
    clientSecret,
    insideElements = false
}) => {

    return (
        <form id="personal-details-form" className="w-100 mr-13" onSubmit={e => e.preventDefault()}>
            <ContactDetails />
            {insideElements && clientSecret && (<PaymentDetails clientSecret={clientSecret}/>)}
            <TermsAndConditions />
        </form>
    )
}